export default [
  '-d',
  '--data'
] as const
